import { Button } from "@/components/ui/button";
import { MessageCircle, Eye, Phone } from "lucide-react";

const HeroSection = () => {
  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="accueil" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background with gradient */}
      <div className="absolute inset-0 gradient-subtle"></div>
      
      {/* Background image overlay */}
      <div className="absolute inset-0 bg-white/60"></div>
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="text-center lg:text-left">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Gâteaux sur mesure à{" "}
              <span className="text-pink-600 font-extrabold">
                Villeurbanne
              </span>{" "}
              🍰
            </h1>
            
            <p className="text-xl md:text-2xl text-gray-600 mb-8 font-light">
              Des créations gourmandes, élégantes et faites avec amour.
            </p>
            
            <div className="prose prose-lg text-gray-700 mb-10 max-w-none">
              <p>
                Chez Sweets by Gem, chaque gâteau raconte une histoire. Qu'il s'agisse d'un anniversaire, 
                d'un mariage ou d'un événement spécial, Gemima crée pour vous un gâteau unique, beau et savoureux, 
                adapté à votre thème et à votre budget.
              </p>
            </div>
            
            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button
                size="lg"
                onClick={() => scrollToSection("#contact")}
                className="gradient-primary text-white shadow-elegant hover:shadow-glow transition-smooth text-lg px-8 py-4"
              >
                <Phone className="w-5 h-5 mr-2" />
                Commander / Réserver
              </Button>
              
              <Button
                variant="outline"
                size="lg"
                onClick={() => scrollToSection("#creations")}
                className="border-2 border-primary text-primary hover:bg-primary hover:text-white transition-smooth text-lg px-8 py-4"
              >
                <Eye className="w-5 h-5 mr-2" />
                Voir nos créations
              </Button>
            </div>
            
            {/* Quick Contact */}
            <div className="mt-8 pt-8 border-t border-pink-200">
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 text-sm text-gray-600">
                <div className="flex items-center">
                  <Phone className="w-4 h-4 mr-2 text-primary" />
                  <span>+33 7 53 79 76 98</span>
                </div>
                <div className="hidden sm:block text-gray-400">•</div>
                <div className="flex items-center">
                  <MessageCircle className="w-4 h-4 mr-2 text-primary" />
                  <span>gemimankdu9@icloud.com</span>
                </div>
                <div className="hidden sm:block text-gray-400">•</div>
                <div className="text-primary font-medium">
                  📍 3 rue Magenta, 69100 Villeurbanne
                </div>
              </div>
            </div>
          </div>
          
          {/* Hero Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-elegant">
              <img
                src="/images/wedding1.jpg"
                alt="Gâteau élégant avec fleurs blanches - Sweets by Gem"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
            
            {/* Floating elements */}
            <div className="absolute -top-4 -right-4 bg-white rounded-full p-4 shadow-gold">
              <span className="text-2xl">🎂</span>
            </div>
            <div className="absolute -bottom-4 -left-4 bg-white rounded-full p-4 shadow-gold">
              <span className="text-2xl">✨</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-primary rounded-full flex justify-center">
          <div className="w-1 h-3 bg-primary rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;